import React, { FC } from "react";
import { Divider } from "@mui/material";
import { SingleOption } from "./SingleOption";
import { FontFamilySelector } from "./FontFamilySelector";

interface Props {
  onUpdate: (key: string, value: string) => void;
  settings: any;
  fonts: any;
}

export const ColorSelectors: FC<Props> = (props) => {
  const { settings, onUpdate } = props;
  return (
    <div className="flex w-[40%] flex-col gap-4 p-4 px-6">
      <SingleOption
        name="Background"
        value={settings.bgColor || '#ffffff'}
        onValueChange={(val) => onUpdate("bgColor", val)}
      />
      <SingleOption
        name="Text color"
        value={settings.textColor || '#000000'}
        onValueChange={(val) => onUpdate("textColor", val)}
      />
      <SingleOption
        name="Title"
        value={settings.titleColor || '#000000'}
        onValueChange={(val) => onUpdate("titleColor", val)}
      />
      <SingleOption
        name="Navigation"
        value={settings.navigationColor || '#a58450'}
        onValueChange={(val) => onUpdate("navigationColor", val)}
      />
      <Divider />
      <FontFamilySelector {...props} />
    </div>
  );
};
